export const CONFIG_REDUCER_PATH = 'config';
